export const CheckTickIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M2.91406 9.10367L5.96559 12.7253L13.0858 4.2749" stroke="#151515" strokeWidth="1.5" strokeLinecap="round"
          strokeLinejoin="round"/>
  </svg>
)
